import { COMPANY_NAME } from '@piccolohealth/pbs-common';
import { ChakraV3, Spin } from '@piccolohealth/ui';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { FaRegCheckCircle, FaRegClock } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AuthCard } from './components/AuthCard';
import { AuthLayout } from './components/AuthLayout';

export const Logout = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isIdleLogout = searchParams.get('reason') === 'idle';

  const logout = React.useCallback(async () => {
    await auth.logout();
  }, [auth.logout]);

  const { mutate, isLoading, isIdle } = useMutation({ mutationFn: logout });

  React.useEffect(() => {
    mutate();
  }, [mutate]);

  const onClickLogin = () => {
    void navigate('/login');
  };

  if (isLoading || isIdle) {
    return (
      <AuthLayout>
        <Spin />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <AuthCard>
        <ChakraV3.Stack gap={4} align='center'>
          <ChakraV3.Icon color={isIdleLogout ? 'warning' : 'success'} boxSize={16}>
            {isIdleLogout ? <FaRegClock /> : <FaRegCheckCircle />}
          </ChakraV3.Icon>
          <ChakraV3.Text fontSize='sm' textAlign='center'>
            {isIdleLogout
              ? `You have been logged out of ${COMPANY_NAME} due to inactivity`
              : `You are now logged out of ${COMPANY_NAME}`}
          </ChakraV3.Text>
          <ChakraV3.Button w='full' size='md' colorPalette='brand' onClick={onClickLogin}>
            Login
          </ChakraV3.Button>
        </ChakraV3.Stack>
      </AuthCard>
    </AuthLayout>
  );
};
